<nb-card class="full-content">
  <nb-card-header> {{data.year}}年 折線圖
    <div class="container">
      <nb-select class="right" placeholder="選擇時間" [(selected)]="selectedTime" (selectedChange)="selectedChange()">
        <nb-option value="0">上半年</nb-option>
        <nb-option value="1">下半年</nb-option>
      </nb-select>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div echarts [options]="lineChartOption" [merge]="lineChartUpdates" class="full-content"></div>
  </nb-card-body>
</nb-card>
